import { render } from "./BuildingCreate.vue?vue&type=template&id=1e230c86"
import script from "./BuildingCreate.vue?vue&type=script&lang=js"
export * from "./BuildingCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__